import {IApiService} from '../../../../types/src';

export class SlackService {
  client: IApiService;
  constructor({client}: {client: IApiService}) {
    this.client = client;
  }
  serviceName = 'slack';

  authorize(params: {redirect_uri: string}) {
    return this.client.get(
      `${this.serviceName}/oauth2/authorize?redirect_uri=${encodeURIComponent(params.redirect_uri)}`,
      ''
    );
  }

  listChannels() {
    return this.client.get(`${this.serviceName}/integrations/channels`, '');
  }

  getProfile() {
    return this.client.get(`${this.serviceName}/integrations/profile`, '');
  }

  updateProfile(data: any) {
    return this.client.post(`${this.serviceName}/integrations/update`, data);
  }

  disconnect() {
    return this.client.delete(`${this.serviceName}/integrations/delete`, {});
  }

  oauth2Redirect(params: {state: string; code: string; redirect_uri: string}) {
    return this.client.get(`${this.serviceName}/oauth2/redirect`, params);
  }
}
